import { Question } from './question.js';

export class EngagementTriggerQuestion extends Question {
    renderNextButton() {
        let nextButton = document.createElement('button');
        nextButton.classList.add('ph-btn--primary');
        nextButton.textContent = this.question.buttonName;
        nextButton.addEventListener('click', () => {
            this.ctx.trackBehavior(this.question, 'next');
            this.ctx.goNext(this.question, null);
        });
        return nextButton;
    }
}
